/**
 * Route copy for `src/routes/status` (keys: `routes.status.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  statusPage: {
    allSystemsOperational: 'All systems operational',
    degradedPerformanceOnSomeComponents: 'Degraded performance on some components',
    majorIncidentInProgress: 'Major incident in progress',
    statusUnavailableForNow: 'Status unavailable for now',
    operational: 'Operational',
    degraded: 'Degraded',
    down: 'Down',
    unknown: 'Unknown',
    fastLatency: 'Fast latency',
    normalLatency: 'Normal latency',
    highLatency: 'High latency',
    unknownError: 'Unknown error',
    platformStatus: 'Platform status',
    realTimeAvailabilityOfServicesAnd: 'Real-time availability of services and service level objectives (SLO).',
    refreshing: 'Refreshing…',
    refresh: 'Refresh',
    loadingServiceStatus: 'Loading service status…',
    couldNotRetrieveTheServiceStatus: 'Could not retrieve the service status',
    tryAgain: 'Try again',
    totalCountComponentsOperationalUpdated: '/{{total_count}} components operational · Updated',
    serviceLevelObjectives: 'Service level objectives',
    targetAvailability: 'Target availability',
    targetP95Latency: 'Target p95 latency',
    targetP99Latency: 'Target p99 latency',
    components: 'Components',
    noComponentToShow: 'No component to show',
    theDetailedStatusIsTemporarilyUnavailabl: 'The detailed status is temporarily unavailable.',
    lastRefreshFailedErrorTheData: 'Last refresh failed ({{error}}) — the data shown may be stale.',
  },
};

export default en;
